import {useState, Suspense} from "react";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import App from "./App.jsx";
import Rooms from "./rooms/Rooms.jsx";

const queryClient = new QueryClient()

export default function Modules({room, products, previousPage}) {
    const [showVisualizer, setShowVisualizer] = useState(true);
    const [roomData, setRoomData] = useState({});

    // Room selection
    const _handleRoomClick = (e) => {
        const selectedRoom = e.target.dataset.room
        if(selectedRoom !== undefined && selectedRoom != roomData.id) {
            let temp = room;
            if(roomData.id) temp = roomData;
            temp.id = selectedRoom;
            setRoomData(temp);
        }
        setShowVisualizer(true);
    };

    // Room selection
    const _handleBackToRooms = (error) => {
        if(error) {
            // display the error
        }
        setShowVisualizer(false);
        //setRoomData({});
    };

    return <>
        { roomData.id && showVisualizer ?
            <QueryClientProvider client={queryClient}>
                <App
                    room={roomData}
                    productsQuery={products}
                    _handleBackToRooms={_handleBackToRooms}
                />
            </QueryClientProvider> :
            <QueryClientProvider client={queryClient}>
                <Rooms
                    previousPage={previousPage}
                    _handleRoomClick={_handleRoomClick}
                />
            </QueryClientProvider>
        }
    </>
}